
class ParcelUtils{
    static asc = arr => arr.sort((a, b) => a - b);

    /*static filterParcelData = (features, carac) => {
        const arr = features.map(f => f.properties[carac])
        const sortedArr = this.asc(arr);
        const valP005 =  this.getPercentilValue(sortedArr,0.05);
        const valP095 =  this.getPercentilValue(sortedArr,0.95);
        const sortedFilteredArr = sortedArr.filter(v => v >= valP005 && v <= valP095);
        const nbToRemove = Math.floor(sortedArr.length * 5/100);
        const sortedFilteredArr = sortedArr.slice(nbToRemove,-nbToRemove);
        return sortedFilteredArr;
    }*/

    static getPercentilValue = (sortedArr, p) => {
        const pos = (sortedArr.length - 1) * p;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sortedArr[base + 1] !== undefined) {
            return sortedArr[base] + rest * (sortedArr[base + 1] - sortedArr[base]);
        } else {
            return sortedArr[base];
        }
    };

    static getPercentilValues = (sortedFilteredArr, percentils) => { 
        let percentilValues =[]
        percentils.forEach(p => {
            let val = this.getPercentilValue(sortedFilteredArr, p)
            val = Math.round(val * 100)/100.0
            percentilValues.push(val)
        })
        return percentilValues;
    }

    static removeOutlayersData = (features, carac) => {
        const sortedFeatures = this.sortByCarac(features, carac);
        const nbToRemove = Math.floor(sortedFeatures.length * 5/100);
        return sortedFeatures.slice(nbToRemove,-nbToRemove);
    }
      
    static sortByCarac = (arr, carac) => {
        let arrCopy = JSON.parse(JSON.stringify(arr));
        return arrCopy.sort((a, b) => a.properties[carac] - b.properties[carac]);
    };

}
export default ParcelUtils;
